import { YLanguage } from '../y/i18n';

export interface UIVarDefinitions {
    'ui-edit-language': YLanguage;
}

export interface UITriggerDefinitions {
    'ui-copy-language': [YLanguage, YLanguage];
    'ui-translate-language': [YLanguage, YLanguage];
}

declare global {
    export interface Element {
        ui_vars?: { [K: string]: any }
        ui_watchers?: { [K: string]: (value: any, old_value: any) => void };
        ui_listeners?: { [K: string]: (value: any) => void };
        ui_set<K extends keyof UIVarDefinitions>(key: K, value: UIVarDefinitions[K]): void;
        ui_get<K extends keyof UIVarDefinitions>(key: K): UIVarDefinitions[K] | undefined;
        ui_watch<K extends keyof UIVarDefinitions>(key: K, handler: (value: UIVarDefinitions[K], old_value: UIVarDefinitions[K] | undefined) => void): void;
        ui_listen<K extends keyof UITriggerDefinitions>(key: K, handler: (value: UITriggerDefinitions[K]) => void): void;
        ui_trigger<K extends keyof UITriggerDefinitions>(key: K, value: UITriggerDefinitions[K]): void;
    }
}

Element.prototype.ui_set = function <K extends keyof UIVarDefinitions>(key: K, value: UIVarDefinitions[K] | undefined) {
    if(!this.ui_vars)
        this.ui_vars = {};

    const old_value = this.ui_vars[key];
    if(value === old_value)
        return;

    this.ui_vars[key] = value;
    this.classList.toggle('ui-const-' + key, value !== undefined);

    for(const e of this.getElementsByClassName('ui-watch-' + key)) {
        e.ui_watchers?.[key]?.(value, old_value);
    }
}

Element.prototype.ui_get = function <K extends keyof UIVarDefinitions>(key: K): UIVarDefinitions[K] | undefined {
    const e = this.closest('.ui-const-' + key);
    if(!e) return undefined;
    return e.ui_vars && e.ui_vars[key];
}

Element.prototype.ui_watch = function <K extends keyof UIVarDefinitions>(key: K, handler: (value: UIVarDefinitions[K], old_value: UIVarDefinitions[K]) => void) {
    if(!this.ui_watchers)
        this.ui_watchers = {};

    this.ui_watchers[key] = handler;
    this.classList.add('x-attach');
    this.classList.add('ui-watch-' + key);
}

Element.prototype.ui_listen = function <K extends keyof UITriggerDefinitions>(key: K, handler: (value: UITriggerDefinitions[K]) => void) {
    if(!this.ui_listeners)
        this.ui_listeners = {};

    this.ui_listeners[key] = handler;
    this.classList.add('ui-listen-' + key);
}

Element.prototype.ui_trigger = function <K extends keyof UITriggerDefinitions>(key: K, value: UITriggerDefinitions[K]) {
    for(const e of this.getElementsByClassName('ui-listen-' + key)) {
        e.ui_listeners?.[key]?.(value);
    }
}
